<template>
    <div class="reply-item-wrapper">
        <TextEditor :value="data" :placeholder="placeholder" @change="inputChange" :hiddenBtns="hiddenBtns" />
        <span class="reply-type">{{ replyType }}</span>
    </div>
</template>

<script>
import TextEditor from "@/views/zhiji/components/textEditor/Editor";

export default {
    name: "ReplyItem",
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    components: {
        TextEditor
    },
    computed: {
        replyType() {
            return this.$t(`zhiji.answer.replyType.${this.data.replyType}`);
        },
        placeholder() {
            return this.$t("zhiji.answer.packageWidge.wordsHolder");
        },
        hiddenBtns() {
            return {
                portrait: true
            };
        }
    },
    watch: {},
    methods: {
        inputChange(data) {
            this.$emit("replyTextChange", Object.assign({}, this.data, data));
        }
    }
};
</script>

<style lang="less" scoped>
/deep/.text-editor-wrapper {
    width: 100%;
    height: 120px !important;
    border: 1px solid #d8e4f0 !important;
}

/deep/.textarea-tip {
    display: none;
}
.reply-item-wrapper {
    position: relative;
    margin-bottom: 8px;
    .reply-type {
        position: absolute;
        left: 10px;
        bottom: 10px;
    }
}
</style>
